import styled from 'styled-components';
import { themeGet, is } from '../../theme/utils';

export const Anchor = styled.a<{ isActive?: boolean; prominentStyle?: boolean }>`
  cursor: pointer;
  outline: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  touch-action: manipulation;
  transition: ${themeGet.transition('color', 'fast')};
  font-size: ${themeGet.fontSize(4)};
  color: ${themeGet.colors('kilamanjaro')};
  &:hover {
    color: ${themeGet.colors('primary')};
  }
  ${is('isActive')`
    color: ${themeGet.colors('primary')};
  `}

  ${is('prominentStyle')`
    color: ${themeGet.colors('primary')};
    text-decoration: underline;
  `}
`;
